import React from 'react';
import { Monitor, Home, Film, CreditCard, UtensilsCrossed, ShoppingCart, Fuel, Plane, Zap, Heart, Shirt, GraduationCap, MoreHorizontal } from 'lucide-react';

const categoryConfig = {
  electronics: { icon: Monitor, color: 'bg-blue-100 text-blue-700' },
  household_goods: { icon: Home, color: 'bg-amber-100 text-amber-700' },
  entertainment: { icon: Film, color: 'bg-purple-100 text-purple-700' },
  subscriptions: { icon: CreditCard, color: 'bg-indigo-100 text-indigo-700' },
  dining: { icon: UtensilsCrossed, color: 'bg-orange-100 text-orange-700' },
  groceries: { icon: ShoppingCart, color: 'bg-green-100 text-green-700' },
  fuel: { icon: Fuel, color: 'bg-rose-100 text-rose-700' },
  travel: { icon: Plane, color: 'bg-sky-100 text-sky-700' },
  utilities: { icon: Zap, color: 'bg-yellow-100 text-yellow-700' },
  health: { icon: Heart, color: 'bg-pink-100 text-pink-700' },
  clothing: { icon: Shirt, color: 'bg-violet-100 text-violet-700' },
  education: { icon: GraduationCap, color: 'bg-teal-100 text-teal-700' },
  other: { icon: MoreHorizontal, color: 'bg-slate-100 text-slate-700' }
};

export default function CategoryBadge({ category, size = 'default' }) {
  const config = categoryConfig[category] || categoryConfig.other;
  const Icon = config.icon;
  const sizes = { sm: 'px-2 py-0.5 text-xs gap-1', default: 'px-3 py-1 text-sm gap-1.5', lg: 'px-4 py-2 text-base gap-2' };
  const iconSizes = { sm: 'w-3 h-3', default: 'w-4 h-4', lg: 'w-5 h-5' };
  return (
    <span className={`inline-flex items-center ${sizes[size]} ${config.color} rounded-full font-medium capitalize`}>
      <Icon className={iconSizes[size]} />
      {category?.replace(/_/g, ' ')}
    </span>
  );
}

export { categoryConfig };
